<h3>Consulta Gerencial</h3>
<a href="#" class="sr-only">Consulta Gerencial</a>

<div class="row">
    <div class="col-sm-12">
        <div class="br-card bg-gray-5">
            <form [formGroup]="formFiltro">
                <div class="card-content">
                    <div class="row">
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-orgao">Órgão (Obrigatório)</label>
                            <frq-select-orgao id="campo-orgao" [required]="false" [bloquearQuandoUnicoItem]="true" [style]="{ width: '100%' }" (changeCallback)="onChangeOrgao()"></frq-select-orgao>
                        </div>
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-upag">UPAG</label>
                            <frq-select-upag id="campo-upag" [required]="false" [idOrgao]="formFiltro.controls.codigoOrgao.value" (changeCallback)="onChangeUpag()"></frq-select-upag>
                        </div>
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-uorg">UORG{{ selecaoUorgObrigatoria && !uorgUnicaBloqueada ? " (Obrigatório)" : "" }}</label>
                            <frq-select-uorg id="campo-uorg" [required]="selecaoUorgObrigatoria && !uorgUnicaBloqueada" [idOrgao]="formFiltro.controls.codigoOrgao.value" [idUpag]="formFiltro.controls.codigoUpag.value" (opcoesCarregadas)="onOpcoesUorgCarregadas($event)"></frq-select-uorg>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4 mt-2 br-input" [ngClass]="{ danger: formFiltro.controls['cpf'].invalid }">
                            <label for="campo-cpf">CPF do agente público</label>
                            <input id="campo-cpf" pInputText frqValidCpf mask="000.000.000-00" maxlength="14" formControlName="cpf" placeholder="000.000.000-00" />
                            <p class="mt-1" *ngIf="formFiltro.controls['cpf'].errors?.['invalidCpf'] && submetido">
                                <span class="feedback danger" role="alert">
                                    <i class="fas fa-times-circle" aria-hidden="true"></i>
                                    CPF inválido
                                </span>
                            </p>
                        </div>
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-nome-servidor">Nome do agente público</label>
                            <input id="campo-nome-servidor" pInputText formControlName="nome" placeholder="Informe o nome ou parte do nome" />
                        </div>
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-matricula-servidor">Matrícula do agente público</label>
                            <input id="campo-matricula-servidor" pInputText type="text" inputmode="numeric" maxlength="7" formControlName="matricula" (input)="onMatriculaInput()" placeholder="Informe a matrícula" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <label for="campo-exercicio" class="consulta-label-com-hint">
                                <span>Exercício das férias (Obrigatório)</span>
                                <i aria-hidden="true" class="fas fa-info-circle text-interactive desktop-only" [pTooltip]="hintExercicio"></i>
                                <i aria-hidden="true" class="fas fa-info-circle text-interactive mobile-only" [pTooltip]="hintExercicio" tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                            </label>
                            <p-dropdown id="campo-exercicio" optionValue="id" optionLabel="label" [options]="opcoesExercicio" [filter]="false" [showClear]="false" [formControlName]="'exercicio'" styleClass="mt-1 consulta-exercicio-dropdown" [overlayOptions]="{ appendTo: 'body' }">
                                <ng-template pTemplate="dropdownicon">
                                    <span class="fas fa-chevron-down"></span>
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row mt-2">
                        <div class="col text-right">
                            <button aria-label="botão limpar" id="botao-limpar" pButton type="button" label="Limpar" class="mr-2" (click)="limpar()"></button>
                            <button aria-label="botão pesquisar" id="botao-pesquisar" pButton type="button" label="Pesquisar" class="primary" (click)="pesquisar()"></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="row mt-2" *ngIf="totalizadores">
    <div class="col-12 col-lg-4 mb-2">
        <div class="br-card consulta-card consulta-card--aguardando">
            <div class="card-content">
                <div class="consulta-card-cabecalho">
                    <div class="consulta-card-titulo-wrap">
                        <span class="consulta-card-icone consulta-card-icone--aguardando">
                            <i class="fas fa-clock"></i>
                        </span>
                        <p class="consulta-card-titulo">Aguardando homologação</p>
                    </div>
                    <i aria-hidden="true" class="fas fa-info-circle consulta-card-info desktop-only" [pTooltip]="hintAguardandoHomologacao"></i>
                    <i aria-hidden="true" class="fas fa-info-circle consulta-card-info mobile-only" [pTooltip]="hintAguardandoHomologacao" tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                </div>
                <p class="consulta-card-valor consulta-card-valor--aguardando">
                    {{ totalizadores.aguardandoHomologacao }}
                </p>
                <a href="#" class="consulta-card-link" [class.disabled]="totalizadores.aguardandoHomologacao === 0" [style.pointer-events]="totalizadores.aguardandoHomologacao === 0 ? 'none' : 'auto'" [style.opacity]="totalizadores.aguardandoHomologacao === 0 ? '0.5' : '1'" (click)="abrirDetalhesAguardandoHomologacao($event)">Detalhar</a>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-4 mb-2">
        <div class="br-card consulta-card consulta-card--sem-programacao">
            <div class="card-content">
                <div class="consulta-card-cabecalho">
                    <div class="consulta-card-titulo-wrap">
                        <span class="consulta-card-icone consulta-card-icone--sem-programacao">
                            <i class="far fa-calendar-alt"></i>
                        </span>
                        <p class="consulta-card-titulo">Exercício sem programação</p>
                    </div>
                    <i aria-hidden="true" class="fas fa-info-circle consulta-card-info desktop-only" [pTooltip]="hintExercicioSemProgramacao"></i>
                    <i aria-hidden="true" class="fas fa-info-circle consulta-card-info mobile-only" [pTooltip]="hintExercicioSemProgramacao" tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                </div>
                <p class="consulta-card-valor consulta-card-valor--sem-programacao">
                    {{ totalizadores.exercicioSemProgramacao }}
                </p>
                <a href="#" class="consulta-card-link" [class.disabled]="totalizadores.exercicioSemProgramacao === 0" [style.pointer-events]="totalizadores.exercicioSemProgramacao === 0 ? 'none' : 'auto'" [style.opacity]="totalizadores.exercicioSemProgramacao === 0 ? '0.5' : '1'" (click)="abrirDetalhesExercicioSemProgramacao($event)">Detalhar</a>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-4 mb-2">
        <div class="br-card consulta-card consulta-card--homologadas">
            <div class="card-content">
                <div class="consulta-card-cabecalho">
                    <div class="consulta-card-titulo-wrap">
                        <span class="consulta-card-icone consulta-card-icone--homologadas">
                            <i class="fas fa-check-circle"></i>
                        </span>
                        <p class="consulta-card-titulo">Férias homologadas</p>
                    </div>
                    <i aria-hidden="true" class="fas fa-info-circle consulta-card-info desktop-only" [pTooltip]="hintFeriasHomologadas"></i>
                    <i aria-hidden="true" class="fas fa-info-circle consulta-card-info mobile-only" [pTooltip]="hintFeriasHomologadas" tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                </div>
                <p class="consulta-card-valor consulta-card-valor--homologadas">
                    {{ totalizadores.feriasHomologadas }}
                </p>
                <a href="#" class="consulta-card-link" [class.disabled]="totalizadores.feriasHomologadas === 0" [style.pointer-events]="totalizadores.feriasHomologadas === 0 ? 'none' : 'auto'" [style.opacity]="totalizadores.feriasHomologadas === 0 ? '0.5' : '1'" (click)="abrirDetalhesFeriasHomologadas($event)">Detalhar</a>
            </div>
        </div>
    </div>
</div>

<div class="row mt-3" *ngIf="carregandoDetalhesAguardandoHomologacao || carregandoDetalhesExercicioSemProgramacao || carregandoDetalhesFeriasHomologadas">
    <div class="col-12">
        <div class="consulta-detalhe-carregando">Carregando detalhamento...</div>
    </div>
</div>

<div class="row mt-3 br-table" *ngIf="detalhesAguardandoHomologacao">
    <div class="col-12">
        <div class="br-card consulta-detalhamento-card">
            <div class="card-header consulta-detalhamento-header">
                <div class="consulta-detalhamento-header__info">
                    <h5 class="mb-0">Detalhamento - Aguardando homologação</h5>
                    <p class="mt-1 mb-0 text-base">
                        Total de registros encontrados:
                        {{ detalhesAguardandoHomologacao.totalRegistros || 0 }}
                    </p>
                </div>
                <div class="consulta-detalhamento-header__acao">
                    <button pButton type="button" class="secondary" [disabled]="exportandoCsvAguardandoHomologacao" [label]="exportandoCsvAguardandoHomologacao ? 'Exportando CSV...' : 'Exportar CSV'" (click)="exportarCsvAguardandoHomologacao()"></button>
                </div>
            </div>
            <div class="card-content p-0">
                <p-table [value]="detalhesAguardandoHomologacao.lista || []" [autoLayout]="true" responsiveLayout="stack" paginatorStyleClass="force-up" styleClass="consulta-gerencial-detalhes-table" [lazy]="true" [paginator]="true" [rows]="tamanhoPaginaDetalhes" [rowsPerPageOptions]="[10, 25, 50, 100]" [first]="(detalhesAguardandoHomologacao.numeroPagina || 0) * tamanhoPaginaDetalhes" [totalRecords]="detalhesAguardandoHomologacao.totalRegistros || 0" (onPage)="onMudancaPaginaDetalhes($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Matrícula e nome do agente público</th>
                            <th>Exercício das férias</th>
                            <th>Nome da chefia da unidade de exercício</th>
                            <th>E-mail da chefia da unidade de exercício</th>
                            <th class="text-center" style="width: 240px">Ação</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-registro>
                        <tr>
                            <td>
                                <span class="p-column-title">Matrícula e nome do agente público</span>
                                {{ registro.matriculaNomeServidor }}
                            </td>
                            <td>
                                <span class="p-column-title">Exercício das férias</span>
                                {{ registro.exercicioFerias }}
                            </td>
                            <td>
                                <span class="p-column-title">Nome da chefia da unidade de exercício</span>
                                {{ registro.nomeChefiaUnidadeExercicio }}
                            </td>
                            <td>
                                <span class="p-column-title">E-mail da chefia da unidade de exercício</span>
                                {{ registro.emailChefiaUnidadeExercicio }}
                            </td>
                            <td class="text-center">
                                <p-menu #menuAguardando [model]="menuAguardandoSelecionado" [popup]="true"></p-menu>
                                <p-button styleClass="m-2 circle" icon="fas fa-bars" (click)="abrirMenuAguardandoHomologacao($event, menuAguardando, registro)"></p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="5">Nenhum resultado encontrado</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>

<div class="row mt-3 br-table" *ngIf="detalhesExercicioSemProgramacao">
    <div class="col-12">
        <div class="br-card consulta-detalhamento-card">
            <div class="card-header consulta-detalhamento-header">
                <div class="consulta-detalhamento-header__info">
                    <h5 class="mb-0">Detalhamento - Exercício sem programação</h5>
                    <p class="mt-1 mb-0 text-base">
                        Total de registros encontrados:
                        {{ detalhesExercicioSemProgramacao.totalRegistros || 0 }}
                    </p>
                </div>
                <div class="consulta-detalhamento-header__acao">
                    <button pButton type="button" class="secondary" [disabled]="exportandoCsvExercicioSemProgramacao" [label]="exportandoCsvExercicioSemProgramacao ? 'Exportando CSV...' : 'Exportar CSV'" (click)="exportarCsvExercicioSemProgramacao()"></button>
                </div>
            </div>
            <div class="card-content p-0">
                <p-table [value]="detalhesExercicioSemProgramacao.lista || []" [autoLayout]="true" responsiveLayout="stack" paginatorStyleClass="force-up" styleClass="consulta-gerencial-detalhes-table" [lazy]="true" [paginator]="true" [rows]="tamanhoPaginaDetalhes" [rowsPerPageOptions]="[10, 25, 50, 100]" [first]="(detalhesExercicioSemProgramacao.numeroPagina || 0) * tamanhoPaginaDetalhes" [totalRecords]="detalhesExercicioSemProgramacao.totalRegistros || 0" (onPage)="onMudancaPaginaDetalhes($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Matrícula e nome do agente público</th>
                            <th>Exercício das férias</th>
                            <th>Nome da chefia da unidade de exercício</th>
                            <th>E-mail da chefia da unidade de exercício</th>
                            <th class="text-center" style="width: 220px">Ações</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-registro>
                        <tr>
                            <td>
                                <span class="p-column-title">Matrícula e nome do agente público</span>
                                {{ registro.matriculaNomeServidor }}
                            </td>
                            <td>
                                <span class="p-column-title">Exercício das férias</span>
                                {{ registro.exercicioFerias }}
                            </td>
                            <td>
                                <span class="p-column-title">Nome da chefia da unidade de exercício</span>
                                {{ registro.nomeChefiaUnidadeExercicio }}
                            </td>
                            <td>
                                <span class="p-column-title">E-mail da chefia da unidade de exercício</span>
                                {{ registro.emailChefiaUnidadeExercicio }}
                            </td>
                            <td class="text-center">
                                <p-menu #menuSemProgramacao [model]="menuSemProgramacaoSelecionado" [popup]="true"></p-menu>
                                <p-button styleClass="m-2 circle" icon="fas fa-bars" (click)="abrirMenuExercicioSemProgramacao($event, menuSemProgramacao, registro)"></p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="5">Nenhum resultado encontrado</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>

<div class="row mt-3 br-table" *ngIf="detalhesFeriasHomologadas">
    <div class="col-12">
        <div class="br-card consulta-detalhamento-card">
            <div class="card-header consulta-detalhamento-header">
                <div class="consulta-detalhamento-header__info">
                    <h5 class="mb-0">Detalhamento - Férias homologadas</h5>
                    <p class="mt-1 mb-0 text-base">
                        Total de registros encontrados:
                        {{ detalhesFeriasHomologadas.totalRegistros || 0 }}
                    </p>
                </div>
                <div class="consulta-detalhamento-header__acao">
                    <button pButton type="button" class="secondary" [disabled]="exportandoCsvFeriasHomologadas" [label]="exportandoCsvFeriasHomologadas ? 'Exportando CSV...' : 'Exportar CSV'" (click)="exportarCsvFeriasHomologadas()"></button>
                </div>
            </div>
            <div class="card-content p-0">
                <p-table [value]="detalhesFeriasHomologadas.lista || []" [autoLayout]="true" responsiveLayout="stack" paginatorStyleClass="force-up" styleClass="consulta-gerencial-detalhes-table" [lazy]="true" [paginator]="true" [rows]="tamanhoPaginaDetalhes" [rowsPerPageOptions]="[10, 25, 50, 100]" [first]="(detalhesFeriasHomologadas.numeroPagina || 0) * tamanhoPaginaDetalhes" [totalRecords]="detalhesFeriasHomologadas.totalRegistros || 0" (onPage)="onMudancaPaginaDetalhes($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Matrícula e nome do agente público</th>
                            <th>Exercício das férias</th>
                            <th>Parcela</th>
                            <th>Dias</th>
                            <th>Início</th>
                            <th>Fim</th>
                            <th>Situação da parcela</th>
                            <th class="text-center" style="width: 180px">Ação</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-registro>
                        <tr>
                            <td>
                                <span class="p-column-title">Matrícula e nome do agente público</span>
                                {{ registro.matriculaNomeServidor }}
                            </td>
                            <td>
                                <span class="p-column-title">Exercício das férias</span>
                                {{ registro.exercicioFerias }}
                            </td>
                            <td>
                                <span class="p-column-title">Parcela</span>
                                <div *ngFor="let parcela of registro.parcelas || []">
                                    {{ parcela.numeroParcela }}
                                </div>
                            </td>
                            <td>
                                <span class="p-column-title">Dias</span>
                                <div *ngFor="let parcela of registro.parcelas || []">
                                    {{ parcela.dias }}
                                </div>
                            </td>
                            <td>
                                <span class="p-column-title">Início</span>
                                <div *ngFor="let parcela of registro.parcelas || []">
                                    {{ parcela.inicio }}
                                </div>
                            </td>
                            <td>
                                <span class="p-column-title">Fim</span>
                                <div *ngFor="let parcela of registro.parcelas || []">
                                    {{ parcela.fim }}
                                </div>
                            </td>
                            <td>
                                <span class="p-column-title">Situação da parcela</span>
                                <div *ngFor="let parcela of registro.parcelas || []">
                                    {{ parcela.situacao }}
                                </div>
                            </td>
                            <td class="text-center">
                                <p-menu #menuFeriasHomologadas [model]="menuFeriasHomologadasSelecionado" [popup]="true"></p-menu>
                                <p-button styleClass="m-2 circle" icon="fas fa-bars" (click)="abrirMenuFeriasHomologadas($event, menuFeriasHomologadas, registro)"></p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="8">Nenhum resultado encontrado</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
